import { Box, Flex, type FlexProps, keyframes } from '@chakra-ui/react';

import { RevelioTooltip } from '@revelio/ui';

import { AiSearchIcon } from '../filterForms/talent-discovery/ai-search/AiSearchIcon';

interface AiSearchChipProps extends FlexProps {
  isGenerating: boolean;
  tooltipLabel?: string;
}

export const DEFAULT_AI_SEARCH_TOOLTIP_LABEL = 'AI Search';

export const AiSearchChip = ({
  isGenerating,
  tooltipLabel = DEFAULT_AI_SEARCH_TOOLTIP_LABEL,
  ...rest
}: AiSearchChipProps) => {
  const animation = `${gradientShift} 8s ease infinite`;
  const iconAnimation = `${zoomAnimation} 2s ease-in-out infinite`;

  return (
    <RevelioTooltip label={tooltipLabel} placement="top-start">
      <Flex
        bgGradient="linear(to-r, #2674D1, #5AD0D0, #9ADF7A)"
        borderRadius="4px"
        p="2px"
        animation={isGenerating ? animation : undefined}
        backgroundSize={isGenerating ? '400% 400%' : undefined}
        role="button"
        {...rest}
        data-testid="ai-search-chip"
      >
        <Flex
          alignItems="center"
          gap={2}
          px="5px"
          py="4px"
          bgGradient={
            isGenerating ? 'linear(to-r, #2F99FB, #6CF2F2, #B5FF9B)' : undefined
          }
          backgroundColor="white"
          backgroundSize="400% 400%"
          animation={isGenerating ? animation : undefined}
          borderRadius="3px"
          overflow="hidden"
        >
          <Box animation={isGenerating ? iconAnimation : undefined}>
            <AiSearchIcon />
          </Box>
        </Flex>
      </Flex>
    </RevelioTooltip>
  );
};

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const zoomAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;
